import {SUPPORT_ACTIONS} from "../actions/types";

export default (state = null, {type, value}) => {
	switch(type) {
		case SUPPORT_ACTIONS.SET:
			return value;
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/supportReducer.js